import create from './create';
import reducer from './reducer';
import wrapConnect from './wrapConnect';

export { reducer };
export { create as createLoader };
export { wrapConnect };



// WEBPACK FOOTER //
// ./src/loader/index.js